import { createAppExt } from './app.js';
import 'scripts/controller/controller.js';

window.createAppExt = createAppExt;

const isPuppeteerWalkerUA = () => {
	return /puppeteer-walker/i.test(navigator.userAgent);
};

const isSSRPage = () => {
	return document.documentElement.hasAttribute('data-ssr');
};

const shouldHydrate = (element) => {
	return element.hasAttribute('data-hydratable');
};

document.querySelectorAll('v-scope, [v-scope]').forEach(element => {
	if (isPuppeteerWalkerUA() || isSSRPage()) {
		createAppExt(element, {
			hydratableSnapshot: isPuppeteerWalkerUA(),
			hydrate: shouldHydrate(element),
			unwrapAfterHydrate: isSSRPage()
		});

		return;
	}

	createAppExt(element);
});

if (!isPuppeteerWalkerUA() && !isSSRPage()) {
	document.querySelectorAll('div[id^="comp_"]').forEach((el) => {
		const parent = el.parentNode;

		if (!parent) {
			return;
		}

		while (el.firstChild) {
			parent.insertBefore(el.firstChild, el);
		}
		parent.removeChild(el);
	});
}
